
import axios from "axios";

export const getProviders = async (): Promise<
    { id: string, name: string } []
> => {
    try {
        const response = await axios.get(`/api/providers`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas pobierania plików:", error);
        throw error;
    }
};